import { Checkbox } from "../../form-fields/components/checkbox";
import { type TextInputProps } from "../../form-fields/components/text-input";
import { FormControlLabel } from "../../form-fields/form-control-label";
import { Stack } from "../../stack";
import { useFieldContext } from "../form/form-context";
import { FieldInfo } from "./fieldinfo";

type TextFieldProps = {
	label: string;
	ariaLabel?: string;
	onChange?: (checked?: boolean) => void;
} & TextInputProps;

export const CheckboxField = ({ label, ariaLabel, onChange }: TextFieldProps) => {
	const field = useFieldContext<boolean>();

	return (
		<Stack gap={2}>
			{label ? (
				<FormControlLabel label={label} gap={2}>
					<Checkbox
						checked={!!field.state.value}
						name={field.name}
						onChange={() => {
							field.handleChange(!field.state.value);
							onChange?.(!field.state.value);
						}}
					/>
				</FormControlLabel>
			) : (
				<label aria-label={ariaLabel}>
					<Checkbox
						checked={!!field.state.value}
						name={field.name}
						onChange={() => {
							field.handleChange(!field.state.value);
							onChange?.(!field.state.value);
						}}
						withOutline
					/>
				</label>
			)}

			<FieldInfo field={field} />
		</Stack>
	);
};
